import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-score-comparison-toggle',
  template: `
    <div class="insight-comparison" *ngIf="visible">
      <span id="showDeviation" [class.showDeviationClicked]="showComparisonFlag">
        <input type="checkbox" [id]="checkboxId" [checked]="showComparisonFlag" (change)="onToggle($event)" />
        <label [attr.for]="checkboxId">
          <img *ngIf="!showComparisonFlag" class="default-img" src="assets/images/checkbox-blank-circle-outline.svg" alt="" />
          <img *ngIf="showComparisonFlag" class="active-img" src="assets/images/checkBox-circle-fill-svg.svg" alt="" />
          <span class="comparison-text" [class.showDeviationClickedText]="showComparisonFlag">{{ label }}</span>
        </label>
      </span>
    </div>
  `,
  styleUrl: './score-comparison-toggle.component.scss',
  imports: [NgIf]
})
export class ScoreComparisonToggleComponent {
  @Input() showComparisonFlag = false;
  @Input() visible = true;
  @Input() dateType = 'period';
  @Input() label = 'Show Comparison';
  @Input() showDescription = false;
  @Input() checkboxId = 'scoreComparisonCheckbox';
  @Output() showComparisonChange = new EventEmitter<boolean>();

  onToggle(event: Event): void {
    const checked = !!(event?.target as HTMLInputElement)?.checked;
    this.showComparisonChange.emit(checked);
  }
}
